import axios from "axios";
import { APIURL } from "../config";
import useAuth from "../utils/useAuth";


const DeleteUserAPI = async (data) => {
    const user = useAuth()
    const url = APIURL + "/admin/deleteuser"
    return await axios.post(url, { access_token: user.token, ...data })
}

export default DeleteUserAPI